import React from "react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";

export default function DisabledAccess({ email }: { email?: string }) {
  return (
    <div className="login-screen">
      <div className="gw-card" style={{ maxWidth: 560, margin: "48px auto", padding: 24 }}>
        <h2 style={{ marginTop: 0 }}>Kontot är avstängt</h2>
        <p>
          Ditt konto har inaktiverats och du har inte längre åtkomst till systemet.
          Kontakta systemadministratören om du anser att detta är fel.
        </p>
        {email ? (
          <p className="text-muted" style={{ fontSize: 13 }}>
            Inloggat konto: {email}
          </p>
        ) : null}
        <button className="btn" onClick={() => void signOut(auth)}>
          Logga ut
        </button>
      </div>
    </div>
  );
}
